<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import { Copy, Check } from 'lucide-svelte';

  interface Props {
    roomName: string;
    copied?: boolean;
    onCopy?: () => void;
  }

  let { roomName, copied = false, onCopy }: Props = $props();
</script>

<button
  type="button"
  onclick={() => onCopy?.()}
  class="text-xs text-slate-400 hover:text-indigo-300 flex items-center gap-1.5 truncate transition"
  aria-label="Скопировать имя комнаты"
>
  <span class="truncate">
    Комната: <span class="text-indigo-300 font-medium">{roomName}</span>
  </span>
  {#if copied}
    <Check class="w-3 h-3 text-green-400 shrink-0" />
  {:else}
    <Copy class="w-3 h-3 shrink-0" />
  {/if}
</button>
